<template>
  <div class="my_page_empty" v-if="emptyImage">
    <van-empty :image="emptyImage" :description="description" />
  </div>
</template>

<script>
export default {
  props: {
    description: {
      type: String,
      default: "无权限"
    }
  },
  data() {
    return {
      emptyImage: window.loadIMG["emptyImage"]
    };
  }
};
</script>

<style>
.my_page_empty {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/EmptyPage/index.vue